import DEFAULT from 'common/consts/defaults';

const LOCALE_REGEXP = /^\/[a-z]{2}|[a-z]{2}-[a-z]{2}/;
export const SPA_PATHS = ['portal/', 'app/', 'pay/'];

export const resolveHost = (host: string) => {
  return host.indexOf('localhost') === -1
    ? host
    : DEFAULT.MARKET;
};

export const isLocalhost = (host: string) => {
  return (host || '').indexOf('localhost') !== -1;
}

export const isExternalUrl = (url: string): boolean => {
  if (!url) return false;
  return (
    url.toLowerCase().indexOf('http') === 0 ||
    url.toLowerCase().indexOf('mailto') === 0 ||
    url.toLowerCase().indexOf('tel') === 0
  );
};

export const getLangFromPathname = () => {
  const localeInPathname = window.location.pathname.match(LOCALE_REGEXP);
  return localeInPathname ? localeInPathname[0] : DEFAULT.LOCALE;
};

export const isInternalUrl = (url: string): boolean => {
  return (
    (url || '').includes('hoistfinance') || (url || '').includes('localhost')
  );
};

export const isPathFromSpa = (url: string): boolean => {
  return SPA_PATHS.some((path) => (url || '').includes(path));
};

export const getPathnameFromUrl = (url: string) => {
  try {
    const link = new URL(url);
    return link.pathname + link.search;
  } catch {
    return url;
  }
};
